import { Edit, SimpleForm, TextInput } from "react-admin";

export const SpecialtyEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="code" />
      <TextInput source="name" />
      <TextInput source="comment" />
    </SimpleForm>
  </Edit>
);
